import { useRouter } from 'next/router'

import { IUL_LP_URL } from '@/constants'
import { useFeatureVariable } from 'lib/FeaturesAndExperiments/getFeatureVariable'

const REDIRECT_TO_NEW_IUL_FLOW_FEATURE_KEY = 'redirect_to_new_iul_flow'

const NEW_FLOW = '/app/flow/iul-d2c'

export const useRedirectToNewIULFlow = () => {
  const { asPath } = useRouter()

  const pathWithoutQuery = asPath.split('?')[0]
  const isIulPage = pathWithoutQuery.includes(IUL_LP_URL)

  const { isEnabled: isRedirectToNewIULFlowEnabled } = useFeatureVariable(
    REDIRECT_TO_NEW_IUL_FLOW_FEATURE_KEY,
    !isIulPage
  )

  return {
    isRedirectToNewIULFlowEnabled,
    newFlow: NEW_FLOW,
  }
}
